<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <router-link to="/" class="nav-item">
        <a class="logo-mini">
          <div class="logo-img">
            <img :src="logo" alt="logo" />
          </div>
        </a>
      </router-link>
      <router-link to="/" class="simple-text logo-normal logo-texto">
        <span class="logo-texto__marca">{{ title }}</span>
        <span class="logo-texto__producto">Express</span>
      </router-link>
      <button
        type="button"
        class="logo-plegar"
        :aria-label="textoPlegar"
        v-tooltip.right="textoPlegar"
        @click="$sidebar.togglePlegarGrupos()"
      >
        <i
          class="fa"
          :class="
            $sidebar.plegadoGrupos.plegados
              ? 'fa-angle-double-down'
              : 'fa-angle-double-up'
          "
        ></i>
      </button>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot> </slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "oxperta",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
          "oxperta",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "static/img/logo-mini.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    textoPlegar() {
      return this.$sidebar.plegadoGrupos.plegados
        ? "Desplegar todo"
        : "Plegar todo";
    },
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
<style>
/* Plegar/desplegar todos los grupos: discreto, a la derecha de la cabecera */
.sidebar .logo .logo-plegar {
  position: absolute;
  top: 50%;
  right: 14px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #ffffff;
  opacity: 0.5;
  transform: translateY(-50%);
}

/* con el menú cerrado (mini y sin hover) no se muestra */
.sidebar-mini .sidebar:not(:hover) .logo .logo-plegar {
  opacity: 0;
  pointer-events: none;
}

.sidebar .logo .logo-plegar:hover {
  opacity: 1;
  color: #f4b13e;
  background: rgba(255, 255, 255, 0.13);
}

/* Logo y nombre en una fila que no salta de línea: con el menú cerrado (70 px)
   el nombre no cabe y, si saltara, empujaría las opciones hacia abajo */
.sidebar .logo {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  /* mismo alto que la cabecera de la página (TopNavbar): la línea bajo el
     logo coincide con su borde inferior y las opciones empiezan siempre igual */
  height: 61px;
  padding: 0;
}

.sidebar .logo a.logo-mini {
  float: none;
  flex-shrink: 0;
}

/* Nombre junto al logo, con la forma del logo de Oxperta */
.sidebar .logo a.logo-normal.logo-texto {
  flex-shrink: 0;
  white-space: nowrap;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  line-height: 1;
  text-transform: none;
  text-decoration: none !important;
  color: #ffffff;
  transform: none;
  transition: opacity 120ms ease 180ms;
}

.sidebar .logo .logo-texto__marca {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.sidebar .logo .logo-texto__producto {
  align-self: flex-end;
  margin-top: 2px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  opacity: 0.85;
}

@media (min-width: 992px) {
  /* La marca permanece fija mientras se anima el ancho del menu. */
  .sidebar-mini .sidebar .logo a.logo-normal.logo-texto {
    transform: none;
  }

  .sidebar-mini .sidebar:not(:hover) .logo a.logo-normal.logo-texto {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 80ms ease, visibility 0s linear 80ms;
  }

  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
